<template>
    <ImageViewer
        :inline="inline"
        :model="model"
        :src="src"
        :draggable="draggable"
        :width="width"
        :height="height"
        v-if="type === 'picture'"/>
    <VideoViewer
        :inline="inline"
        :model="model"
        :src="src"
        :draggable="draggable"
        :width="width"
        :height="height"
        v-else-if="type === 'video'"/>
    <AudioViewer
        :inline="inline"
        :model="model"
        :src="src"
        :draggable="draggable"
        :width="width"
        :height="height"
        v-else-if="type === 'audio'"/>
    <SurveyViewer
        :inline="inline"
        :model="model"
        :src="src"
        :draggable="draggable"
        :width="width"
        :height="height"
        v-else-if="type === 'survey'"/>
    <TextViewer
        :inline="inline"
        :model="model"
        :src="src"
        :draggable="draggable"
        :width="width"
        :height="height"
        v-else-if="type === 'text'"/>
    <ArticleViewer
        :inline="inline"
        :model="model"
        :draggable="draggable"
        :width="width"
        :height="height"
        v-else-if="type === 'article'"/>
    <BadgeComponent
        :inline="inline"
        :model="model"
        :draggable="draggable"
        :width="width"
        :height="height"
        v-else-if="type === 'badge'"/>
    <SurveyQuestionComponent
        :backgroundUrl="customBackgroundUrl"
        :backgroundColor="customBackgroundColor"
        :inline="inline"
        :model="model"
        :draggable="draggable"
        :width="width"
        :height="height"
        v-else-if="type === 'surveyQuestion'"/>
    <article-part-viewer
        :backgroundUrl="customBackgroundUrl"
        :backgroundColor="customBackgroundColor"
        :inline="inline"
        :model="model"
        :draggable="draggable"
        :width="width"
        :height="height"
        v-else-if="type === 'articlePart'"/>
    <span v-else></span>
</template>

<script>
    import ImageViewer from './ImageViewer'
    import VideoViewer from './VideoViewer'
    import SurveyViewer from './SurveyViewer'
    import TextViewer from './TextViewer'
    import AudioViewer from './AudioViewer'
    import SurveyQuestionComponent from '../SurveyQuestionComponent'
    import ArticlePartViewer from './ArticlePartViewer'
    import BadgeComponent from '../../BadgeComponent'
    const ArticleViewer = () => import('./ArticleViewer')

    export default {
        name: 'GenericViewer',
        components: {
            BadgeComponent,
            ArticlePartViewer,
            SurveyQuestionComponent,
            ArticleViewer, AudioViewer, SurveyViewer, VideoViewer, ImageViewer, TextViewer},
        props: ['tasklet', 'draggable', 'src', 'articlePart', 'surveyQuestion', 'inline',
            'backgroundUrl', 'backgroundColor', 'overrideBackgroundFromModel', 'width', 'height'],
        computed: {
            customBackgroundUrl () {
                if (this.overrideBackgroundFromModel && this.overrideBackgroundFromModel.backgroundUrl) {
                    return this.overrideBackgroundFromModel.backgroundUrl
                }
                return this.backgroundUrl
            },
            customBackgroundColor () {
                if (this.overrideBackgroundFromModel && this.overrideBackgroundFromModel.backgroundColor) {
                    return this.overrideBackgroundFromModel.backgroundColor
                }
                return this.backgroundColor
            },
            type () {
                if (this.src) {
                    if (this.src.endsWith('.mp3') || this.src.endsWith('.wav')){
                        return 'audio'
                    } else if (this.src.endsWith('.png') || this.src.endsWith('.jpg') || this.src.endsWith('.gif')) {
                        return 'picture'
                    } else if (this.src.endsWith('.mp4') || this.src.endsWith('.mpg') || this.src.endsWith('.mov')) {
                        return 'video'
                    } else {
                        // TODO - handle model for poll(survey) and article
                    }
                } else if (this.tasklet && this.tasklet.type) {
                    return this.tasklet.type
                } else if (this.articlePart && this.articlePart.articlePartId) {
                    return 'articlePart'
                } else if (this.surveyQuestion && this.surveyQuestion.surveyQuestionId) {
                    return 'surveyQuestion'
                }
            },
            model () {
                if (this.articlePart && this.articlePart.articlePartId) {
                    return this.articlePart
                } else if (this.surveyQuestion && this.surveyQuestion.surveyQuestionId) {
                    return this.surveyQuestion
                } else {
                    return this.tasklet
                }
            },
            style () {
                let s = '';

                if (this.inline) {
                    s += 'display: inline; '
                }

                if (this.width) {
                    s += `width: ${this.width}px; `
                }

                if (this.height) {
                    s += `height: ${this.height}px; `
                }

                return s
            }
        }
    }
</script>

<style scoped lang="scss">
    .me {
        text-align: center;
    }
</style>